export default __webpack_public_path__ + "static/0201-7db7a006f52ba3f9ed7b39bc6561d097.png";